import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BACKEND_URL}/notification`;

export const getUserNotifications = (userId) => {
  return axios.get(`${API_URL}/${userId}`);
};

export const markNotificationAsRead = (id) => {
  return axios.put(`${API_URL}/${id}/read`);
};

export const getUnreadCount = (userId) => {
  return axios.get(`${API_URL}/unread/${userId}`);
};
